import { render, staticRenderFns } from "./InvoicesApprove.vue?vue&type=template&id=ecf5d776&scoped=true&"
import script from "./InvoicesApprove.vue?vue&type=script&lang=js&"
export * from "./InvoicesApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf5d776",
  null
  
)

export default component.exports